<template>
  <section>
    <div
      v-if="config"
      class="page-a4"
      :style="`background-image: url(/print/${config.bg})`"
    >
      <slot></slot>
      <pText
        v-for="(item, n) of config.items"
        :key="n"
        v-if="item.condition"
        :left="item.left ? item.left + 'mm' : null"
        :top="item.top ? item.top + 'mm' : null"
        :right="item.right ? item.right + 'mm' : null"
        :bottom="item.bottom ? item.bottom + 'mm' : null"
        :width="item.width ? item.width + 'mm' : null"
        :height="item.height ? item.height + 'mm' : null"
        :pt="item.pt ? item.pt + 'mm' : null"
        :pl="item.pl ? item.pl + 'mm' : null"
        :pb="item.pb ? item.pb + 'mm' : null"
        :bold="item.style ? item.style.includes('bold') : null"
        :bolder="item.style ? item.style.includes('bolder') : null"
        :bg="item.style ? item.style.includes('bg') : null"
        :font12="item.style ? item.style.includes('font12') : null"
        :font13="item.style ? item.style.includes('font13') : null"
        :font14="item.style ? item.style.includes('font14') : null"
        :font15="item.style ? item.style.includes('font15') : null"
        :font16="item.style ? item.style.includes('font16') : null"
        :font17="item.style ? item.style.includes('font17') : null"
        :font18="item.style ? item.style.includes('font18') : null"
        :font19="item.style ? item.style.includes('font19') : null"
        :font20="item.style ? item.style.includes('font20') : null"
        :font21="item.style ? item.style.includes('font21') : null"
        :font22="item.style ? item.style.includes('font22') : null"
        :font24="item.style ? item.style.includes('font24') : null"
        :font26="item.style ? item.style.includes('font26') : null"
        :font28="item.style ? item.style.includes('font28') : null"
        :font30="item.style ? item.style.includes('font30') : null"
        :font34="item.style ? item.style.includes('font34') : null"
        :font38="item.style ? item.style.includes('font38') : null"
        :font40="item.style ? item.style.includes('font40') : null"
        :textAlign="item.textAlign ? item.textAlign : null"
        v-html="item.text"
      ></pText>
    </div>
    <div v-else class="page-a4">
      <slot></slot>
    </div>
  </section>
</template>

<script>
import "@/assets/page.scss";
import pText from "@/components/Print/text";
export default {
  props: ["config"],
  components: { pText },
};
</script>
